// import { useEffect, useMemo, useState } from "react";
// import { Link, useParams } from "react-router-dom";
// import axios from "../../api/httpClient";
// import FetchLoadingState from "../../components/feedback/FetchLoadingState";
// import { buildAssetUrl, getApiBaseUrl } from "../../data/authStorage";
// import { readSessionCache, writeSessionCache } from "../../utils/sessionCache";

// const COMMENT_PAGE_SIZE = 10;

// const formatDateTime = (value) => {
//   if (!value) return "-";
//   const parsed = new Date(value);
//   if (Number.isNaN(parsed.getTime())) return value;
//   return parsed.toLocaleString();
// };

// const mentionMatch = (text) => {
//   const value = `${text || ""}`;
//   const match = value.match(/(^|\s)@([^\s@]*)$/);
//   if (!match) return null;
//   return {
//     query: (match[2] || "").trim().toLowerCase(),
//     start: match.index + match[1].length,
//     end: value.length,
//   };
// };

// const renderMentions = (text) => {
//   const chunks = `${text || ""}`.split(/(@\[[^\]]+\])/g);
//   return chunks.map((chunk, index) => {
//     if (/^@\[[^\]]+\]$/.test(chunk)) {
//       return (
//         <span
//           key={`mention-${index}`}
//           className="font-medium text-[#1234CD]"
//         >
//           {chunk}
//         </span>
//       );
//     }
//     return <span key={`text-${index}`}>{chunk}</span>;
//   });
// };

// const EngagementPage = () => {
//   const { id } = useParams();
//   const apiBaseUrl = getApiBaseUrl();
//   const cacheKey = useMemo(() => `cehr_engagement_post_${id || "unknown"}`, [id]);
//   const cachedData = useMemo(() => readSessionCache(cacheKey, { post: null }), [cacheKey]);
//   const [post, setPost] = useState(cachedData?.post || null);
//   const [employees, setEmployees] = useState([]);
//   const [loading, setLoading] = useState(!cachedData?.post);
//   const [loadingMoreComments, setLoadingMoreComments] = useState(false);
//   const [error, setError] = useState("");
//   const [commentBody, setCommentBody] = useState("");
//   const [savingComment, setSavingComment] = useState(false);
//   const [reactionLoading, setReactionLoading] = useState(null);
//   const [commentPage, setCommentPage] = useState(1);
//   const [hasMoreComments, setHasMoreComments] = useState(false);
//   const [activeMention, setActiveMention] = useState(null);

//   const loadPost = async (options = {}) => {
//     if (!apiBaseUrl || !id) {
//       setError("Invalid post route.");
//       return null;
//     }

//     const page = options.commentPage || 1;

//     try {
//       if (options.appendComments) {
//         setLoadingMoreComments(true);
//       } else if (!options.silent && !post) {
//         setLoading(true);
//       }
//       setError("");
//       const response = await axios.get(
//         `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(id)}`,
//         {
//           params: {
//             viewer: "admin",
//             commentPage: page,
//             commentLimit: COMMENT_PAGE_SIZE,
//           },
//         },
//       );

//       const payloadPost = response?.data?.post || null;
//       const pagination = response?.data?.commentPagination || {};
//       setCommentPage(Number(pagination?.page || page));
//       setHasMoreComments(Boolean(pagination?.hasMore));

//       if (payloadPost) {
//         if (options.appendComments) {
//           setPost((prev) => ({
//             ...(prev || {}),
//             ...payloadPost,
//             comments: [
//               ...(prev?.comments || []),
//               ...(payloadPost.comments || []),
//             ],
//           }));
//         } else {
//           setPost(payloadPost);
//           writeSessionCache(cacheKey, { post: payloadPost });
//         }
//       }

//       return payloadPost;
//     } catch (requestError) {
//       const message =
//         requestError?.response?.data?.message || "Unable to load post.";
//       setError(Array.isArray(message) ? message.join(", ") : message);
//       if (!options.appendComments && !post) {
//         setPost(null);
//       }
//       return null;
//     } finally {
//       if (options.appendComments) {
//         setLoadingMoreComments(false);
//       } else {
//         setLoading(false);
//       }
//     }
//   };

//   const loadEmployees = async () => {
//     if (!apiBaseUrl) return;
//     try {
//       const response = await axios.get(
//         `${apiBaseUrl}/organizations/employees`,
//         {
//           params: { status: "approved" },
//         },
//       );
//       setEmployees(response?.data?.employees || []);
//     } catch {
//       setEmployees([]);
//     }
//   };

//   useEffect(() => {
//     loadEmployees();
//   }, [apiBaseUrl]);

//   useEffect(() => {
//     loadPost({ commentPage: 1, silent: true });
//   }, [apiBaseUrl, id]);

//   useEffect(() => {
//     const handleFocusRefresh = () => {
//       if (document.visibilityState !== "hidden") {
//         loadPost({ commentPage: 1, silent: true });
//       }
//     };

//     window.addEventListener("focus", handleFocusRefresh);
//     document.addEventListener("visibilitychange", handleFocusRefresh);

//     return () => {
//       window.removeEventListener("focus", handleFocusRefresh);
//       document.removeEventListener("visibilitychange", handleFocusRefresh);
//     };
//   }, [apiBaseUrl, id, post]);

//   const react = async (type) => {
//     if (!apiBaseUrl || !post?.id) return;

//     try {
//       setReactionLoading(type);
//       await axios.post(
//         `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(post.id)}/reactions`,
//         {
//           reactionType: type,
//         },
//       );
//       await loadPost({ commentPage: 1 });
//     } catch (requestError) {
//       const message =
//         requestError?.response?.data?.message || "Unable to react to post.";
//       setError(Array.isArray(message) ? message.join(", ") : message);
//     } finally {
//       setReactionLoading(null);
//     }
//   };

//   const addComment = async () => {
//     if (!apiBaseUrl || !post?.id) return;

//     const body = `${commentBody || ""}`.trim();
//     if (!body) {
//       setError("Comment cannot be empty.");
//       return;
//     }

//     try {
//       setSavingComment(true);
//       setError("");
//       await axios.post(
//         `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(post.id)}/comments`,
//         {
//           body,
//         },
//       );
//       setCommentBody("");
//       setActiveMention(null);
//       await loadPost({ commentPage: 1 });
//     } catch (requestError) {
//       const message =
//         requestError?.response?.data?.message || "Unable to comment.";
//       setError(Array.isArray(message) ? message.join(", ") : message);
//     } finally {
//       setSavingComment(false);
//     }
//   };

//   const deleteComment = async (commentId) => {
//     if (!apiBaseUrl || !post?.id) return;

//     try {
//       await axios.delete(
//         `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(post.id)}/comments/${encodeURIComponent(commentId)}`,
//       );
//       await loadPost({ commentPage: 1 });
//     } catch (requestError) {
//       const message =
//         requestError?.response?.data?.message || "Unable to delete comment.";
//       setError(Array.isArray(message) ? message.join(", ") : message);
//     }
//   };

//   const loadMoreComments = async () => {
//     if (!hasMoreComments || loadingMoreComments) return;
//     await loadPost({ commentPage: commentPage + 1, appendComments: true });
//   };

//   const mentionCandidates = useMemo(() => {
//     if (!activeMention) return [];
//     const query = activeMention.query || "";
//     return (employees || [])
//       .filter((employee) => {
//         const text =
//           `${employee.name || ""} ${employee.emailAddress || ""}`.toLowerCase();
//         return query ? text.includes(query) : true;
//       })
//       .slice(0, 6);
//   }, [activeMention, employees]);

//   const updateComment = (value) => {
//     setCommentBody(value);
//     setActiveMention(mentionMatch(value));
//   };

//   const insertMention = (employee) => {
//     const mention = mentionMatch(commentBody);
//     if (!mention) return;
//     const token = `@[${employee.name || "employee"}]`;
//     const updated = `${commentBody.slice(0, mention.start)}${token} ${commentBody.slice(mention.end)}`;
//     setCommentBody(updated);
//     setActiveMention(null);
//   };

//   if (loading) {
//     return <FetchLoadingState message="Loading post..." className="min-h-[320px]" />;
//   }

//   if (!post) {
//     return (
//       <div className="p-6 font-Outfit">
//         {error ? <p className="mb-3 text-sm text-red-600">{error}</p> : null}
//         <Link
//           to="/engagement"
//           className="text-sm text-[#1234CD] underline"
//         >
//           Back to Engagement
//         </Link>
//       </div>
//     );
//   }

//   const imageAttachment = (post.attachments || []).find(
//     (item) => item.type === "Image",
//   );
//   const videoAttachment = (post.attachments || []).find(
//     (item) => item.type === "Video",
//   );
//   const linkAttachments = (post.attachments || []).filter(
//     (item) => item.type === "Link",
//   );

//   return (
//     <div className="min-h-screen bg-white p-6 font-Outfit">
//       <div className="mb-4 flex items-center justify-between">
//         <Link
//           to="/engagement"
//           className="text-sm text-[#1234CD] underline"
//         >
//           Back to Engagement
//         </Link>
//         <div className="flex flex-wrap items-center gap-2">
//           <span
//             className={`rounded-full px-3 py-1 text-xs font-semibold ${post.isEnabled ? "bg-[#ECFDF3] text-[#027A48]" : "bg-[#FFF1F3] text-[#B42318]"}`}
//           >
//             {post.isEnabled ? "Visible" : "Hidden"}
//           </span>
//           {post.isPinned ? (
//             <span className="rounded-full bg-[#EFF8FF] px-3 py-1 text-xs font-semibold text-[#175CD3]">
//               Pinned
//             </span>
//           ) : null}
//           {post.isScheduled ? (
//             <span className="rounded-full bg-[#FEF7E0] px-3 py-1 text-xs font-semibold text-[#B54708]">
//               Scheduled
//             </span>
//           ) : null}
//         </div>
//       </div>

//       {error ? <p className="mb-3 text-sm text-red-600">{error}</p> : null}

//       <h1 className="text-2xl font-semibold text-[#071C50]">{post.title}</h1>
//       <p className="mt-1 text-xs text-[#667085]">
//         Posted {formatDateTime(post.createdAt)}
//       </p>
//       {post.scheduledFor ? (
//         <p className="mt-1 text-xs text-[#B54708]">
//           Scheduled for {formatDateTime(post.scheduledFor)}
//         </p>
//       ) : null}
//       {post.creditedEmployee ? (
//         <p className="mt-2 text-sm text-[#1234CD]">
//           Credit: {post.creditedEmployee.name} (
//           {post.creditedEmployee.email || "-"})
//         </p>
//       ) : null}
//       <p className="mt-4 whitespace-pre-wrap text-sm text-[#344054]">
//         {post.body}
//       </p>

//       {imageAttachment ? (
//         <div className="mt-4">
//           <img src={buildAssetUrl(imageAttachment.url)} alt={imageAttachment.label || "post"} className="h-56 w-full rounded-xl object-cover" />
//         </div>
//       ) : null}

//       {videoAttachment ? (
//         <div className="mt-4 space-y-3">
//           <video controls className="max-h-[420px] w-full rounded-xl bg-black" src={buildAssetUrl(videoAttachment.url)} />
//         </div>
//       ) : null}

//       {linkAttachments.length > 0 ? (
//         <div className="mt-4 space-y-2 rounded-xl bg-[#F8FAFF] p-3">
//           {linkAttachments.map((attachment) => (
//             <a
//               key={attachment.id}
//               href={attachment.url}
//               target="_blank"
//               rel="noreferrer"
//               className="block break-all text-sm text-[#1234CD] underline"
//             >
//               {attachment.url}
//             </a>
//           ))}
//         </div>
//       ) : null}

//       <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-[#EEF1FB] pt-4 text-sm">
//         <button
//           type="button"
//           onClick={() => react("Like")}
//           disabled={!!reactionLoading}
//           className={`rounded-lg border px-3 py-1 disabled:cursor-not-allowed disabled:opacity-70 ${post.viewerReaction === "Like" ? "border-[#1234CD] bg-[#EEF2FF] text-[#1234CD]" : "border-[#D0D7F2]"}`}
//         >
//           {reactionLoading === "Like"
//             ? "Liking..."
//             : `Like (${post.reactionSummary?.likes || 0})`}
//         </button>
//         <button
//           type="button"
//           onClick={() => react("Dislike")}
//           disabled={!!reactionLoading}
//           className={`rounded-lg border px-3 py-1 disabled:cursor-not-allowed disabled:opacity-70 ${post.viewerReaction === "Dislike" ? "border-[#B42318] bg-[#FFF1F3] text-[#B42318]" : "border-[#D0D7F2]"}`}
//         >
//           {reactionLoading === "Dislike"
//             ? "Disliking..."
//             : `Dislike (${post.reactionSummary?.dislikes || 0})`}
//         </button>
//         <span className="rounded-lg border border-[#D0D7F2] px-3 py-1">
//           Comments ({post.reactionSummary?.comments || 0})
//         </span>
//       </div>

//       <div className="mt-6 rounded-xl border border-[#EEF1FB] p-4">
//         <h3 className="text-lg font-semibold text-[#071C50]">Comments</h3>
//         <div className="mt-3 space-y-3">
//           {(post.comments || []).map((comment) => (
//             <div
//               key={comment.id}
//               className="rounded-lg border border-[#EEF1FB] p-3"
//             >
//               <div className="flex items-start justify-between gap-2">
//                 <div>
//                   <p className="text-sm font-medium text-[#071C50]">
//                     {comment.commenterName}
//                   </p>
//                   <p className="text-xs text-[#667085]">
//                     {comment.commenterEmail || "-"}
//                   </p>
//                   <p className="text-xs text-[#98A2B3]">
//                     {formatDateTime(comment.createdAt)}
//                   </p>
//                 </div>
//                 {comment.commenterType === "Employee" ? (
//                   <button
//                     type="button"
//                     onClick={() => deleteComment(comment.id)}
//                     className="rounded-lg border border-[#F7C5CC] px-2 py-1 text-xs text-[#B42318]"
//                   >
//                     Delete
//                   </button>
//                 ) : null}
//               </div>
//               <p className="mt-2 whitespace-pre-wrap text-sm text-[#344054]">
//                 {renderMentions(comment.body)}
//               </p>
//             </div>
//           ))}
//         </div>

//         {hasMoreComments ? (
//           <div className="mt-3 flex justify-center">
//             <button
//               type="button"
//               onClick={loadMoreComments}
//               disabled={loadingMoreComments}
//               className="rounded-lg border border-[#D0D7F2] px-3 py-2 text-xs"
//             >
//               {loadingMoreComments ? "Loading..." : "Load more comments"}
//             </button>
//           </div>
//         ) : null}

//         <div className="mt-4 border-t border-[#EEF1FB] pt-3">
//           <label className="mb-1 block text-sm font-medium">Add Comment</label>
//           <textarea
//             value={commentBody}
//             onChange={(event) => updateComment(event.target.value)}
//             rows={3}
//             className="w-full rounded-lg border border-[#D0D7F2] px-3 py-2 text-sm"
//           />
//           {activeMention && mentionCandidates.length > 0 ? (
//             <div className="mt-2 max-h-40 overflow-y-auto rounded-lg border border-[#E4E7EC] bg-white">
//               {mentionCandidates.map((employee) => (
//                 <button
//                   key={employee.id}
//                   type="button"
//                   onClick={() => insertMention(employee)}
//                   className="block w-full border-b border-[#F2F4F7] px-3 py-2 text-left text-sm last:border-b-0 hover:bg-[#F8FAFF]"
//                 >
//                   {employee.name} ({employee.emailAddress || "-"})
//                 </button>
//               ))}
//             </div>
//           ) : null}
//           <p className="mt-1 text-xs text-[#98A2B3]">
//             Type @ to mention an employee.
//           </p>
//           <div className="mt-2 flex justify-end">
//             <button
//               type="button"
//               onClick={addComment}
//               disabled={savingComment}
//               className="rounded-lg bg-[#1234CD] px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
//             >
//               {savingComment ? "Posting..." : "Post comment"}
//             </button>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default EngagementPage;

import { useEffect, useMemo, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "../../api/httpClient";
import FetchLoadingState from "../../components/feedback/FetchLoadingState";
import { buildAssetUrl, getApiBaseUrl } from "../../data/authStorage";
import { readSessionCache, writeSessionCache } from "../../utils/sessionCache";
import useCurrentEmployee from "../../hooks/useCurrentEmployee";
import { markEngagementPostsSeen } from "../../utils/engagementUnread";

const COMMENT_PAGE_SIZE = 10;

const getOptimisticReactionPost = (post, reactionType) => {
  const previousReaction = post?.viewerReaction || null;
  const nextReaction = previousReaction === reactionType ? null : reactionType;
  const currentSummary = post?.reactionSummary || {};
  let likes = Number(currentSummary.likes || 0);
  let dislikes = Number(currentSummary.dislikes || 0);

  if (previousReaction === "Like") {
    likes = Math.max(0, likes - 1);
  }
  if (previousReaction === "Dislike") {
    dislikes = Math.max(0, dislikes - 1);
  }
  if (nextReaction === "Like") {
    likes += 1;
  }
  if (nextReaction === "Dislike") {
    dislikes += 1;
  }

  return {
    ...post,
    viewerReaction: nextReaction,
    reactionSummary: {
      ...currentSummary,
      likes,
      dislikes,
    },
  };
};

const reconcileReactionPost = (post, reactionType, responseData) => ({
  ...post,
  viewerReaction: responseData?.action === "removed" ? null : reactionType,
  reactionSummary: {
    ...(post?.reactionSummary || {}),
    ...(responseData?.summary || {}),
  },
});

const formatDateTime = (value) => {
  if (!value) return "-";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return value;
  return parsed.toLocaleString();
};

const mentionMatch = (text) => {
  const value = `${text || ""}`;
  const match = value.match(/(^|\s)@([^\s@]*)$/);
  if (!match) return null;
  return {
    query: (match[2] || "").trim().toLowerCase(),
    start: match.index + match[1].length,
    end: value.length,
  };
};

const renderMentions = (text) => {
  const chunks = `${text || ""}`.split(/(@\[[^\]]+\])/g);
  return chunks.map((chunk, index) => {
    if (/^@\[[^\]]+\]$/.test(chunk)) {
      return (
        <span
          key={`mention-${index}`}
          className="font-medium text-[#1234CD]"
        >
          {chunk}
        </span>
      );
    }
    return <span key={`text-${index}`}>{chunk}</span>;
  });
};

const wasCommentEdited = (comment) => {
  const createdAt = new Date(comment?.createdAt || 0).getTime();
  const updatedAt = new Date(comment?.updatedAt || 0).getTime();
  return Number.isFinite(createdAt) && Number.isFinite(updatedAt) && updatedAt > createdAt + 1000;
};

const EngagementPage = () => {
  const { id } = useParams();
  const apiBaseUrl = getApiBaseUrl();
  const { companyAccount, currentEmployee, loading: employeeLoading } = useCurrentEmployee();
  const actorEmployeeId = companyAccount ? "" : currentEmployee?.id || "";
  const actingAs = companyAccount ? "admin" : "employee";
  const cacheKey = useMemo(
    () => `cehr_engagement_post_${id || "unknown"}`,
    [id],
  );
  const cachedData = useMemo(
    () => readSessionCache(cacheKey, { post: null }),
    [cacheKey],
  );
  const [post, setPost] = useState(cachedData?.post || null);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(!cachedData?.post);
  const [loadingMoreComments, setLoadingMoreComments] = useState(false);
  const [error, setError] = useState("");
  const [commentBody, setCommentBody] = useState("");
  const [savingComment, setSavingComment] = useState(false);
  const [editingCommentId, setEditingCommentId] = useState("");
  const [editingCommentBody, setEditingCommentBody] = useState("");
  const [savingCommentEdit, setSavingCommentEdit] = useState(false);
  const [deleteCommentModal, setDeleteCommentModal] = useState({
    open: false,
    comment: null,
    loading: false,
    error: "",
  });
  const reactionPending = useRef(false);
  const [commentPage, setCommentPage] = useState(1);
  const [hasMoreComments, setHasMoreComments] = useState(false);
  const [activeMention, setActiveMention] = useState(null);
  const [replyingTo, setReplyingTo] = useState(null);
  const commentComposerRef = useRef(null);
  const replyToComment = (comment) => {
    setReplyingTo(comment);
    setCommentBody("");
    setActiveMention(null);
    setError("");
    requestAnimationFrame(() => {
      commentComposerRef.current?.scrollIntoView({ behavior: "smooth", block: "center" });
      commentComposerRef.current?.focus();
    });
  };

  const loadPost = async (options = {}) => {
    if (!apiBaseUrl || !id) {
      setError("Invalid post route.");
      return null;
    }

    const page = options.commentPage || 1;

    try {
      if (options.appendComments) {
        setLoadingMoreComments(true);
      } else if (!options.silent && !post) {
        setLoading(true);
      }
      setError("");
      const response = await axios.get(
        `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(id)}`,
        {
          params: {
            viewer: actingAs,
            employeeId: actorEmployeeId || undefined,
            commentPage: page,
            commentLimit: COMMENT_PAGE_SIZE,
          },
        },
      );

      const payloadPost = response?.data?.post || null;
      const pagination = response?.data?.commentPagination || {};
      setCommentPage(Number(pagination?.page || page));
      setHasMoreComments(Boolean(pagination?.hasMore));

      if (payloadPost) {
        if (options.appendComments) {
          setPost((prev) => ({
            ...(prev || {}),
            ...payloadPost,
            comments: [
              ...(prev?.comments || []),
              ...(payloadPost.comments || []),
            ],
          }));
        } else {
          setPost(payloadPost);
          writeSessionCache(cacheKey, { post: payloadPost });
        }
      }

      return payloadPost;
    } catch (requestError) {
      const message =
        requestError?.response?.data?.message || "Unable to load post.";
      setError(Array.isArray(message) ? message.join(", ") : message);
      if (!options.appendComments && !post) {
        setPost(null);
      }
      return null;
    } finally {
      if (options.appendComments) {
        setLoadingMoreComments(false);
      } else {
        setLoading(false);
      }
    }
  };

  const loadEmployees = async () => {
    if (!apiBaseUrl) return;
    try {
      const response = await axios.get(
        `${apiBaseUrl}/organizations/employees`,
        {
          params: { status: "approved" },
        },
      );
      setEmployees(response?.data?.employees || []);
    } catch {
      setEmployees([]);
    }
  };

  useEffect(() => {
    loadEmployees();
  }, [apiBaseUrl]);

  useEffect(() => {
    if (!companyAccount && employeeLoading) {
      return;
    }

    loadPost({ commentPage: 1, silent: true });
  }, [apiBaseUrl, id, actorEmployeeId, companyAccount, employeeLoading]);

  useEffect(() => {
    if (!companyAccount && actorEmployeeId && post?.id) {
      markEngagementPostsSeen([post], actorEmployeeId);
    }
  }, [actorEmployeeId, companyAccount, post]);

  useEffect(() => {
    const handleFocusRefresh = () => {
      if (document.visibilityState !== "hidden") {
        loadPost({ commentPage: 1, silent: true });
      }
    };

    window.addEventListener("focus", handleFocusRefresh);
    document.addEventListener("visibilitychange", handleFocusRefresh);

    return () => {
      window.removeEventListener("focus", handleFocusRefresh);
      document.removeEventListener("visibilitychange", handleFocusRefresh);
    };
  }, [apiBaseUrl, id, post]);

  const react = async (type) => {
    if (!apiBaseUrl || !post?.id || reactionPending.current) return;

    reactionPending.current = true;

    const previousPost = post;
    const optimisticPost = getOptimisticReactionPost(previousPost, type);
    setPost(optimisticPost);
    writeSessionCache(cacheKey, { post: optimisticPost });

    try {
      setError("");
      const response = await axios.post(
        `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(post.id)}/reactions`,
        {
          reactionType: type,
          employeeId: actorEmployeeId || undefined,
        },
      );
      const reconciledPost = reconcileReactionPost(optimisticPost, type, response?.data || {});
      setPost(reconciledPost);
      writeSessionCache(cacheKey, { post: reconciledPost });
    } catch (requestError) {
      setPost(previousPost);
      writeSessionCache(cacheKey, { post: previousPost });
      const message =
        requestError?.response?.data?.message || "Unable to react to post.";
      setError(Array.isArray(message) ? message.join(", ") : message);
    } finally {
      reactionPending.current = false;
    }
  };

  const addComment = async () => {
    if (!apiBaseUrl || !post?.id) return;

    const body = `${commentBody || ""}`.trim();
    if (!body) {
      setError("Comment cannot be empty.");
      return;
    }

    try {
      setSavingComment(true);
      setError("");
      await axios.post(
        `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(post.id)}/comments`,
        {
          body,
          employeeId: actorEmployeeId || undefined,
          parentCommentId: replyingTo?.id || undefined,
        },
      );
      setCommentBody("");
      setActiveMention(null);
      setReplyingTo(null);
      await loadPost({ commentPage: 1 });
    } catch (requestError) {
      const message =
        requestError?.response?.data?.message || "Unable to comment.";
      setError(Array.isArray(message) ? message.join(", ") : message);
    } finally {
      setSavingComment(false);
    }
  };

  const deleteComment = async (commentId) => {
    if (!apiBaseUrl || !post?.id) return;

    try {
      setDeleteCommentModal((prev) => ({ ...prev, loading: true, error: "" }));
      await axios.delete(
        `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(post.id)}/comments/${encodeURIComponent(commentId)}`,
      );
      await loadPost({ commentPage: 1 });
      setDeleteCommentModal({ open: false, comment: null, loading: false, error: "" });
    } catch (requestError) {
      const message =
        requestError?.response?.data?.message || "Unable to delete comment.";
      setError(Array.isArray(message) ? message.join(", ") : message);
      setDeleteCommentModal((prev) => ({
        ...prev,
        loading: false,
        error: Array.isArray(message) ? message.join(", ") : message,
      }));
    }
  };

  const saveCommentEdit = async (commentId) => {
    const body = `${editingCommentBody || ""}`.trim();
    if (!apiBaseUrl || !post?.id || !body) {
      setError("Comment cannot be empty.");
      return;
    }

    try {
      setSavingCommentEdit(true);
      setError("");
      await axios.patch(
        `${apiBaseUrl}/organizations/engagement/posts/${encodeURIComponent(post.id)}/comments/${encodeURIComponent(commentId)}`,
        { body },
      );
      setEditingCommentId("");
      setEditingCommentBody("");
      await loadPost({ commentPage: 1 });
    } catch (requestError) {
      const message = requestError?.response?.data?.message || "Unable to update comment.";
      setError(Array.isArray(message) ? message.join(", ") : message);
    } finally {
      setSavingCommentEdit(false);
    }
  };

  const loadMoreComments = async () => {
    if (!hasMoreComments || loadingMoreComments) return;
    await loadPost({ commentPage: commentPage + 1, appendComments: true });
  };

  const mentionCandidates = useMemo(() => {
    if (!activeMention) return [];
    const query = activeMention.query || "";
    return (employees || [])
      .filter((employee) => {
        const text =
          `${employee.name || ""} ${employee.emailAddress || ""}`.toLowerCase();
        return query ? text.includes(query) : true;
      })
      .slice(0, 6);
  }, [activeMention, employees]);

  const updateComment = (value) => {
    setCommentBody(value);
    setActiveMention(mentionMatch(value));
  };

  const insertMention = (employee) => {
    const mention = mentionMatch(commentBody);
    if (!mention) return;
    const token = `@[${employee.name || "employee"}]`;
    const updated = `${commentBody.slice(0, mention.start)}${token} ${commentBody.slice(mention.end)}`;
    setCommentBody(updated);
    setActiveMention(null);
  };

  if (loading) {
    return (
      <FetchLoadingState
        message="Loading post..."
        className="min-h-[320px]"
      />
    );
  }

  if (!post) {
    return (
      <div className="p-6 font-Outfit">
        {error ? <p className="mb-3 text-sm text-red-600">{error}</p> : null}
        <Link
          to="/engagement"
          className="text-sm text-[#1234CD] underline"
        >
          Back to Engagement
        </Link>
      </div>
    );
  }

  const imageAttachment = (post.attachments || []).find(
    (item) => item.type === "Image",
  );
  const videoAttachment = (post.attachments || []).find(
    (item) => item.type === "Video",
  );
  const linkAttachments = (post.attachments || []).filter(
    (item) => item.type === "Link",
  );

  return (
    <div className="min-h-screen bg-white p-6 font-Outfit">
      <div className="mb-4 flex items-center justify-between">
        <Link
          to="/engagement"
          className="text-sm text-[#1234CD] underline"
        >
          Back to Engagement
        </Link>
        <div className="flex flex-wrap items-center gap-2">
          <span
            className={`rounded-full px-3 py-1 text-xs font-semibold ${post.isEnabled ? "bg-[#ECFDF3] text-[#027A48]" : "bg-[#FFF1F3] text-[#B42318]"}`}
          >
            {post.isEnabled ? "Visible" : "Hidden"}
          </span>
          {post.isPinned ? (
            <span className="rounded-full bg-[#EFF8FF] px-3 py-1 text-xs font-semibold text-[#175CD3]">
              Pinned
            </span>
          ) : null}
          {post.isScheduled ? (
            <span className="rounded-full bg-[#FEF7E0] px-3 py-1 text-xs font-semibold text-[#B54708]">
              Scheduled
            </span>
          ) : null}
        </div>
      </div>

      {error ? <p className="mb-3 text-sm text-red-600">{error}</p> : null}

      <h1 className="text-2xl font-semibold text-[#071C50]">{post.title}</h1>
      <p className="mt-1 text-xs text-[#667085]">
        Posted {formatDateTime(post.createdAt)}
      </p>
      {post.scheduledFor ? (
        <p className="mt-1 text-xs text-[#B54708]">
          Scheduled for {formatDateTime(post.scheduledFor)}
        </p>
      ) : null}
      {post.creditedEmployee ? (
        <p className="mt-2 text-sm text-[#1234CD]">
          Credit: {post.creditedEmployee.name} (
          {post.creditedEmployee.email || "-"})
        </p>
      ) : null}
      <p className="mt-4 whitespace-pre-wrap text-sm text-[#344054]">
        {post.body}
      </p>

      {imageAttachment ? (
        <div className="mt-4">
          <img
            src={buildAssetUrl(imageAttachment.url)}
            alt={imageAttachment.label || "post"}
            className="h-56 w-full rounded-xl object-cover"
          />
        </div>
      ) : null}

      {videoAttachment ? (
        <div className="mt-4 space-y-3">
          <video
            controls
            className="max-h-[420px] w-full rounded-xl bg-black"
            src={buildAssetUrl(videoAttachment.url)}
          />
        </div>
      ) : null}

      {linkAttachments.length > 0 ? (
        <div className="mt-4 space-y-2 rounded-xl bg-[#F8FAFF] p-3">
          {linkAttachments.map((attachment) => (
            <a
              key={attachment.id}
              href={attachment.url}
              target="_blank"
              rel="noreferrer"
              className="block break-all text-sm text-[#1234CD] underline"
            >
              {attachment.url}
            </a>
          ))}
        </div>
      ) : null}

      <div className="mt-4 flex flex-wrap items-center gap-2 border-t border-[#EEF1FB] pt-4 text-sm">
        <div className="inline-flex overflow-hidden rounded-lg border border-[#D0D7F2]">
          <button type="button" onClick={() => react("Like")} className={`px-3 py-1 ${post.viewerReaction === "Like" ? "bg-[#EEF2FF] text-[#1234CD]" : "bg-white"}`}>Like</button>
          <button type="button" onClick={() => react("Like")} className="border-l border-[#D0D7F2] bg-white px-2.5 py-1 font-semibold text-[#1234CD]" aria-label={`${post.reactionSummary?.likes || 0} likes`}>{post.reactionSummary?.likes || 0}</button>
        </div>
        <div className="inline-flex overflow-hidden rounded-lg border border-[#D0D7F2]">
          <button type="button" onClick={() => react("Dislike")} className={`px-3 py-1 ${post.viewerReaction === "Dislike" ? "bg-[#FFF1F3] text-[#B42318]" : "bg-white"}`}>Dislike</button>
          <button type="button" onClick={() => react("Dislike")} className="border-l border-[#D0D7F2] bg-white px-2.5 py-1 font-semibold text-[#B42318]" aria-label={`${post.reactionSummary?.dislikes || 0} dislikes`}>{post.reactionSummary?.dislikes || 0}</button>
        </div>
        <span className="rounded-lg border border-[#D0D7F2] px-3 py-1">
          Comments ({post.reactionSummary?.comments || 0})
        </span>
      </div>

      <div className="mt-6 rounded-xl border border-[#EEF1FB] p-4">
        <h3 className="text-lg font-semibold text-[#071C50]">Comments</h3>
        <div className="mt-3 space-y-3">
          {(post.comments || []).map((comment) => (
            <div
              key={comment.id}
              className="rounded-lg border border-[#EEF1FB] p-3"
            >
              <div className="flex items-start justify-between gap-2">
                <div>
                  <p className="text-sm font-medium text-[#071C50]">
                    {comment.commenterName}
                  </p>
                  <p className="text-xs text-[#667085]">
                    {comment.commenterEmail || "-"}
                  </p>
                  <p className="text-xs text-[#98A2B3]">
                    {formatDateTime(comment.createdAt)}
                    {wasCommentEdited(comment) ? (
                      <span className="ml-2 rounded-full bg-[#EEF4FF] px-2 py-0.5 font-medium text-[#1234CD]">Edited</span>
                    ) : null}
                  </p>
                </div>
                {comment.canManage ? (
                  <div className="flex gap-2">
                    <button
                      type="button"
                      onClick={() => {
                        setEditingCommentId(comment.id);
                        setEditingCommentBody(comment.body);
                        setError("");
                      }}
                      className="rounded-lg border border-[#D0D7F2] px-2 py-1 text-xs text-[#344054]"
                    >
                      Edit
                    </button>
                    <button type="button" onClick={() => replyToComment(comment)} className="rounded-lg border border-[#D0D7F2] px-2 py-1 text-xs text-[#1234CD]">Reply</button>
                    <button
                      type="button"
                      onClick={() => setDeleteCommentModal({ open: true, comment, loading: false, error: "" })}
                      className="rounded-lg border border-[#F7C5CC] px-2 py-1 text-xs text-[#B42318]"
                    >
                      Delete
                    </button>
                  </div>
                ) : <button type="button" onClick={() => replyToComment(comment)} className="rounded-lg border border-[#D0D7F2] px-2 py-1 text-xs text-[#1234CD]">Reply</button>}
              </div>
              {editingCommentId === comment.id ? (
                <div className="mt-2">
                  <textarea
                    value={editingCommentBody}
                    onChange={(event) => setEditingCommentBody(event.target.value)}
                    rows={3}
                    className="w-full rounded-lg border border-[#D0D7F2] px-3 py-2 text-sm"
                  />
                  <div className="mt-2 flex justify-end gap-2">
                    <button type="button" onClick={() => { setEditingCommentId(""); setEditingCommentBody(""); }} className="rounded-lg border border-[#D0D7F2] px-3 py-1 text-xs">Cancel</button>
                    <button type="button" disabled={savingCommentEdit} onClick={() => saveCommentEdit(comment.id)} className="rounded-lg bg-[#1234CD] px-3 py-1 text-xs font-semibold text-white disabled:opacity-60">{savingCommentEdit ? "Saving..." : "Save"}</button>
                  </div>
                </div>
              ) : (
                <p className="mt-2 whitespace-pre-wrap text-sm text-[#344054]">
                  {renderMentions(comment.body)}
                </p>
              )}
              {(comment.replies || []).length ? <div className="mt-3 space-y-2 border-l-2 border-[#DCE3FF] pl-3 sm:pl-4">{comment.replies.map((reply) => <div key={reply.id} className="rounded-lg bg-[#F8FAFF] p-3"><div className="flex items-start justify-between gap-2"><div><p className="text-sm font-medium text-[#071C50]">{reply.commenterName}</p><p className="text-xs text-[#667085]">{reply.commenterEmail || "-"}</p><p className="text-xs text-[#98A2B3]">{formatDateTime(reply.createdAt)}{wasCommentEdited(reply) ? <span className="ml-2 rounded-full bg-[#EEF4FF] px-2 py-0.5 font-medium text-[#1234CD]">Edited</span> : null}</p></div><div className="flex flex-wrap justify-end gap-2"><button type="button" onClick={() => { setReplyingTo(comment); setCommentBody(""); setActiveMention(null); setError(""); }} className="rounded-lg border border-[#D0D7F2] px-2 py-1 text-xs text-[#1234CD]">Reply</button>{reply.canManage ? <><button type="button" onClick={() => { setEditingCommentId(reply.id); setEditingCommentBody(reply.body); setError(""); }} className="rounded-lg border border-[#D0D7F2] px-2 py-1 text-xs">Edit</button><button type="button" onClick={() => setDeleteCommentModal({ open: true, comment: reply, loading: false, error: "" })} className="rounded-lg border border-[#F7C5CC] px-2 py-1 text-xs text-[#B42318]">Delete</button></> : null}</div></div>{editingCommentId === reply.id ? <div className="mt-2"><textarea value={editingCommentBody} onChange={(event) => setEditingCommentBody(event.target.value)} rows={2} className="w-full rounded-lg border border-[#D0D7F2] px-3 py-2 text-sm" /><div className="mt-2 flex justify-end gap-2"><button type="button" onClick={() => { setEditingCommentId(""); setEditingCommentBody(""); }} className="rounded-lg border px-3 py-1 text-xs">Cancel</button><button type="button" disabled={savingCommentEdit} onClick={() => saveCommentEdit(reply.id)} className="rounded-lg bg-[#1234CD] px-3 py-1 text-xs font-semibold text-white disabled:opacity-60">{savingCommentEdit ? "Saving..." : "Save"}</button></div></div> : <p className="mt-2 whitespace-pre-wrap text-sm text-[#344054]">{renderMentions(reply.body)}</p>}</div>)}</div> : null}
            </div>
          ))}
        </div>

        {hasMoreComments ? (
          <div className="mt-3 flex justify-center">
            <button
              type="button"
              onClick={loadMoreComments}
              disabled={loadingMoreComments}
              className="rounded-lg border border-[#D0D7F2] px-3 py-2 text-xs"
            >
              {loadingMoreComments ? "Loading..." : "Load more comments"}
            </button>
          </div>
        ) : null}

        <div className="mt-4 border-t border-[#EEF1FB] pt-3">
          <div className="mb-1 flex items-center justify-between gap-3"><label className="block text-sm font-medium">{replyingTo ? `Reply to ${replyingTo.commenterName}` : "Add Comment"}</label>{replyingTo ? <button type="button" onClick={() => { setReplyingTo(null); setCommentBody(""); setActiveMention(null); }} className="text-xs font-medium text-[#667085]">Cancel reply</button> : null}</div>
          <textarea
            ref={commentComposerRef}
            value={commentBody}
            onChange={(event) => updateComment(event.target.value)}
            rows={3}
            className="w-full rounded-lg border border-[#D0D7F2] px-3 py-2 text-sm"
          />
          {activeMention && mentionCandidates.length > 0 ? (
            <div className="mt-2 max-h-40 overflow-y-auto rounded-lg border border-[#E4E7EC] bg-white">
              {mentionCandidates.map((employee) => (
                <button
                  key={employee.id}
                  type="button"
                  onClick={() => insertMention(employee)}
                  className="block w-full border-b border-[#F2F4F7] px-3 py-2 text-left text-sm last:border-b-0 hover:bg-[#F8FAFF]"
                >
                  {employee.name} ({employee.emailAddress || "-"})
                </button>
              ))}
            </div>
          ) : null}
          <p className="mt-1 text-xs text-[#98A2B3]">
            Type @ to mention an employee.
          </p>
          <div className="mt-2 flex justify-end">
            <button
              type="button"
              onClick={addComment}
              disabled={savingComment}
              className="rounded-lg bg-[#1234CD] px-4 py-2 text-sm font-semibold text-white disabled:opacity-60"
            >
              {savingComment ? "Posting..." : replyingTo ? "Post reply" : "Post comment"}
            </button>
          </div>
        </div>
      </div>

      {deleteCommentModal.open ? (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4" role="dialog" aria-modal="true" aria-labelledby="delete-comment-title">
          <div className="w-full max-w-md rounded-2xl bg-white p-5 shadow-xl sm:p-6">
            <div className="flex h-11 w-11 items-center justify-center rounded-full bg-red-50 text-xl font-bold text-red-600">!</div>
            <h3 id="delete-comment-title" className="mt-4 text-lg font-semibold text-[#071C50]">Delete comment?</h3>
            <p className="mt-2 text-sm text-[#667085]">This comment will be permanently removed. This action cannot be undone.</p>
            {deleteCommentModal.comment?.body ? <p className="mt-4 line-clamp-3 rounded-xl bg-[#F8FAFC] p-3 text-sm text-[#344054]">{deleteCommentModal.comment.body}</p> : null}
            {deleteCommentModal.error ? <p className="mt-3 text-sm text-red-600" role="alert">{deleteCommentModal.error}</p> : null}
            <div className="mt-6 flex justify-end gap-3">
              <button type="button" disabled={deleteCommentModal.loading} onClick={() => setDeleteCommentModal({ open: false, comment: null, loading: false, error: "" })} className="rounded-lg border border-[#D0D5DD] px-4 py-2 text-sm font-semibold text-[#344054] disabled:opacity-60">Cancel</button>
              <button type="button" disabled={deleteCommentModal.loading} onClick={() => deleteComment(deleteCommentModal.comment.id)} className="rounded-lg bg-[#D92D20] px-4 py-2 text-sm font-semibold text-white disabled:cursor-wait disabled:opacity-60">{deleteCommentModal.loading ? "Deleting..." : "Delete comment"}</button>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default EngagementPage;
